import * as React from 'react'
import { rowsPerPageDrodown, rowsPerPage } from 'types/pagination'
import { DataGrid } from '@material-ui/data-grid'
import { useSelector } from 'react-redux'
import { selectTableSlice } from './tableSlice'
import { Wrapper } from './styles'

export default function DataGridDemo ({
  onRowClick,
  onSelectionModelChange,
  loading,
  setPage
}) {
  const tableSlice = useSelector(selectTableSlice)

  return (
    <Wrapper>
      <div style={{ height: '88vh', width: '100%' }}>
        <DataGrid
          columns={tableSlice.columns}
          rows={tableSlice.rows}
          pageSize={rowsPerPage}
          rowsPerPageOptions={rowsPerPageDrodown}
          onRowClick={onRowClick}
          onPageSizeChange={e => {
            setPage(e)
          }}
          onPageChange={e => {
            setPage(e)
          }}
          loading={loading}
          // checkboxSelection
          // onSelectionModelChange={onSelectionModelChange}
        />
      </div>
    </Wrapper>
  )
}
